










import React, { useState } from "react";
import { motion } from "framer-motion";
import PersonImage from "../images/VIKAS_STUDENT_PIC[1].png"; // Update the path
import QRImage from "../images/scnner.jpg"; // Add your QR code image
import AOS from 'aos';
const BusinessPromo = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };



  return (
    <>
      <style>{`
        .containerss {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 50px;
          font-family: Arial, sans-serif;
          height: auto;
          margin: auto;
          background-color:#2a0947;
          overflow: hidden;
          flex-wrap: wrap;
        }

        .text-sectiony {
          max-width: 50%;
          text-align: left;
        }

        .image-sectiony {
          display: flex;
          justify-content: flex-start;
          width: 50%;
        }

        .imagess {
          width: 100%;
          max-width: 681px;
          border-radius: 10px;
        }

        .headingyss {
          font-size: 50px;
          font-weight: bold;
          color: white;
        }

        .bold {
          color: #ffe124;
        }

        .highlighted {
          color: white;
          border-bottom: 3px solid #ffe124;
          display: inline-block;
        }

        .paragraph {
          font-size: 17px;
          color: white;
          margin: 10px 0 20px;
        }

        .buttonContainer {
          margin-top: 20px;
        }

        .downloadBtn {
          background-color: #ffe124;
          color: #2a0947;
          padding: 12px 25px;
          font-size: 20px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.3s ease;
          font-weight: bold;
        }

        .popupOverlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .popupInner {
          background: white;
          padding: 30px;
          border-radius: 10px;
          text-align: center;
          position: relative;
          max-width: 400px;
          animation: slideUp 0.4s ease;
        }

        .closeBtn {
          position: absolute;
          top: 10px;
          right: 15px;
          font-size: 20px;
          background: none;
          border: none;
          cursor: pointer;
        }

        .scannerImg {
          width: 200px;
          height: auto;
          margin-bottom: 15px;
        }

        @media (max-width: 768px) {
          .containerss {
            flex-direction: column-reverse;
            height: auto;
          }

          .text-sectiony,
          .image-sectiony {
            max-width: 100%;
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .headingyss {
            font-size: 36px;
          }

          .imagess {
            max-width: 90%;
            margin: 0 auto;
          }
        }

        @media (max-width: 480px) {
          .headingyss {
            font-size: 30px;
          }

          .paragraph {
            font-size: 14px;
          }

          .downloadBtn {
            font-size: 16px;
            padding: 10px 20px;
          }

          .scannerImg {
            width: 150px;
          }
        }
      `}</style>

      <div className="containerss">
        {/* Image Section - LEFT */}


        {/* Text Section - RIGHT */}
        <motion.div
          className="text-sectiony"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <p className="headingyss">
            What <span className="bold">Makes To Maamaas</span> <br />
            {/* <span className="bold"></span>  <br /> */}
            <span className="highlighted">Different?</span>
          </p>

          <p className="paragraph">
            Most apps take commissions from vendors – and those costs sneak into your final bill. Not here.
            At Maamaas, we charge ZERO commission from service providers and businesses, which means you pay only what’s fair – just a small, transparent platform fee per booking.
            This keeps your costs low while supporting the actual providers directly. It’s a win-win.
          </p>

          <div className="buttonContainer">
            <button className="downloadBtn" onClick={togglePopup}>
              Download App
            </button>
          </div>

          {showPopup && (
            <div className="popupOverlay">
              <div className="popupInner">
                <button className="closeBtn" onClick={togglePopup}>
                  ×
                </button>
                <img src={QRImage} alt="QR Code Scanner" className="scannerImg" />
                <p>Scan the QR code to download the Maamaas App!</p>
              </div>
            </div>
          )}
        </motion.div>

        <motion.div
          className="image-sectiony"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img src={PersonImage} alt="Person" className="imagess" />
        </motion.div>

      </div>
    </>
  );
};

export default BusinessPromo;
